import React from "react";
import DatePickerController from "../datePickerController";
import {
  getAssessmentAdminSystemManagedDateRows,
  getAdminExtraDateRowLabel,
  getVqaDateFieldValue,
} from "../../utils/assessmentAdminFormHelpers";

function formatReadDate(value, dateFormat) {
  if (value !== null && value !== undefined) {
    return dateFormat(value);
  }
  return "-";
}

/**
 * Post–agreed-draft rows: renamed system-managed / sponsor draft date rows.
 */
export default function AssessmentAdminSystemManagedDateRows({
  vqa,
  updateActive,
  control,
  dateFormat,
  hideWhenNoVqa = true,
}) {
  const hide = hideWhenNoVqa && vqa == null;
  const rows = getAssessmentAdminSystemManagedDateRows();

  return (
    <>
      {rows.map((row) => {
        const value = getVqaDateFieldValue(vqa, row.vqaKey);
        const showPicker = row.editable && updateActive;

        return (
          <div
            key={row.id}
            className="px-0 py-4"
            style={hideWhenNoVqa ? { display: hide && "none" } : undefined}
          >
            <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
              <h2 className="text-sm font-medium text-gray-900">
                {getAdminExtraDateRowLabel(row)}
              </h2>
              <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                <span>
                  <label htmlFor="">
                    {showPicker ? (
                      <DatePickerController
                        control={control}
                        fieldName={row.fieldName}
                        value={value}
                        disableMinDate={true}
                      />
                    ) : (
                      formatReadDate(value, dateFormat)
                    )}{" "}
                  </label>
                </span>
              </p>
            </div>
          </div>
        );
      })}
    </>
  );
}
